import { useQuery } from '@tanstack/react-query'
import { Text } from '@viapeople/components'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { trpc } from '../../utils/trpc'

export function CycleRedirector() {
	const { cycleId } = useParams<{ cycleId: string }>()
	const navigate = useNavigate()

	const {
		data: clearanceData,
		isLoading,
		isError,
	} = useQuery({
		...trpc.client.users.myCycleClearance.queryOptions({ cycleId: cycleId as string }),
		enabled: !!cycleId,
	})

	useEffect(() => {
		if (clearanceData && cycleId) {
			const { isCycleAdmin, isCycleViewer, isCycleManager } = clearanceData

			if (isCycleAdmin) {
				navigate(`/dashboard/${cycleId}/tasks`)
			} else if (isCycleViewer || isCycleManager) {
				navigate(`/dashboard/evaluations-view/${cycleId}`)
			}
		}
	}, [clearanceData, cycleId, navigate])

	if (isLoading) {
		return (
			<div className='flex items-center justify-center min-h-screen'>
				<Text variant='large' weight='regular'>
					Loading...
				</Text>
			</div>
		)
	}

	if (isError) {
		return (
			<div className='flex items-center justify-center min-h-screen'>
				<Text variant='large' weight='regular' className='text-error-600'>
					Error loading permissions. Please try again.
				</Text>
			</div>
		)
	}

	if (clearanceData && !clearanceData.isCycleAdmin && !clearanceData.isCycleViewer && !clearanceData.isCycleManager) {
		return (
			<div className='flex items-center justify-center min-h-screen'>
				<Text variant='large' weight='regular' className='text-neutral-600'>
					You don't have permission to access this cycle.
				</Text>
			</div>
		)
	}

	return (
		<div className='flex items-center justify-center min-h-screen'>
			<Text variant='large' weight='regular'>
				Loading...
			</Text>
		</div>
	)
}
